import PanelLayout from '../layout/PanelLayout';
import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../store/auth-context';
import { useLocation, useNavigate } from 'react-router-dom';
import PanelMenu from '../components/AdminPanel/PanelMenu';
import DistrictsTable from '../components/AdminPanel/DistrictsTable';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import SchoolsTable from '../components/AdminPanel/SchoolsTable';
import TeachersTable from '../components/AdminPanel/TeachersTable';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {
	districtsPage,
	olympicsSettingsPage,
	olympicsStagesPage,
	schoolsPage,
	studentsPage,
	teachersPage,
	emailCampaignsPage,
	managementPage,
	whatsNewPage,
	helpPage,
	panelPage,
} from '../store/fixed-routing';
import StudentsTable from '../components/AdminPanel/StudentsTable';
import SettingsPage from '../components/AdminPanel/SettingsPage';
import StagesTable from '../components/AdminPanel/StagesTable';
import EmailCampaignsPage from '../components/AdminPanel/EmailCampaignsPage';
import ManagementPage from '../components/AdminPanel/ManagementPage';
import WhatsNewPage from '../components/AdminPanel/WhatsNewPage';
import HelpPage from '../components/AdminPanel/HelpPage';
import WhatsNewHost from '../components/AdminPanel/WhatsNewHost';
import { OlympicsContextProvider, OlympicsContext } from '../store/olympics-context';
import { PresentationChromeProvider } from '../store/presentation-chrome-context';
import PanelHeader from '../components/AdminPanel/PanelHeader';
import { useTeacherRegistrationGuard } from '../hooks/useTeacherRegistrationGuard';

const PanelPageContent = () => {
	const { role, logout, firstName, lastName, email } = useContext(AuthContext);
	const { refreshTables } = useContext(OlympicsContext);
	const [index, setIndex] = useState(1);
	const navigate = useNavigate();
	const location = useLocation();

	useTeacherRegistrationGuard();

	useEffect(() => {
		const normalizedPath = location.pathname.replace(/\/+$/, '') || '/';
		if (normalizedPath === panelPage && role === 'teacher') {
			navigate(studentsPage, { replace: true });
			return;
		}
		switch (normalizedPath) {
			case districtsPage:
				setIndex(1);
				break;
			case schoolsPage:
				setIndex(2);
				break;
			case teachersPage:
				setIndex(3);
				break;
			case studentsPage:
				setIndex(4);
				break;
			case olympicsStagesPage:
				setIndex(5);
				break;
			case olympicsSettingsPage:
				setIndex(6);
				break;
			case emailCampaignsPage:
				setIndex(7);
				break;
			case managementPage:
				setIndex(8);
				break;
			case whatsNewPage:
				setIndex(9);
				break;
			case helpPage:
				setIndex(10);
				break;
			default:
				setIndex(1);
		}
	}, [location.pathname, role, navigate]);

	useEffect(() => {
		if (!(role === 'administrator' || role === 'teacher' || role === 'secretary')) {
			navigate('/');
		}
	}, [role]);

	return (
		<PanelLayout>
			<WhatsNewHost />
			<PanelMenu setIndex={setIndex} />
			<Box
				sx={{
					width: { xs: '100%', md: 'calc(100vw - 200px)' },
					height: '100%',
					ml: 'auto',
				}}
			>
				<Grid
					item
					container
					flexDirection={'column'}
					sx={{
						pt: { xs: 0, sm: '30px' },
						pl: { xs: 0, sm: '30px' },
						pr: 0,
						pb: 0,
					}}
				>
					<PanelHeader
						index={index}
						onRefresh={() => {
							console.log('PanelPage: Refresh button clicked');
							refreshTables();
						}}
					/>
					{index === 1 && <DistrictsTable />}
					{index === 2 && <SchoolsTable />}
					{index === 3 && <TeachersTable />}
					{index === 4 && <StudentsTable />}
					{index === 5 && <StagesTable />}
					{index === 6 && <SettingsPage />}
					{index === 7 && <EmailCampaignsPage />}
					{index === 8 && <ManagementPage />}
					{index === 9 && <WhatsNewPage />}
					{index === 10 && <HelpPage />}
				</Grid>
			</Box>
			<Tooltip
				title={
					<Box>
						<Typography
							variant='body2'
							fontWeight='bold'
						>
							{firstName} {lastName}
						</Typography>
						<Typography
							variant='caption'
							display='block'
						>
							{email}
						</Typography>
					</Box>
				}
				placement='bottom-end'
				arrow
			>
				<Button
					size={'medium'}
					startIcon={<LockOpenIcon />}
					onClick={() => logout()}
					variant='contained'
					sx={{
						position: 'fixed',
						top: '10px',
						right: '10px',
						fontSize: '14px',
						flexDirection: 'column',
						py: 1,
						px: 2,
						minWidth: '120px',
						textTransform: 'none',
						boxShadow: 3,
					}}
				>
					<Typography
						variant='body2'
						fontWeight='bold'
						fontSize='14px'
					>
						WYLOGUJ
					</Typography>
					<Typography
						variant='caption'
						fontSize='11px'
						fontWeight='normal'
					>
						{role === 'administrator'
							? 'Administrator'
							: role === 'secretary'
								? 'Sekretarz'
								: role === 'teacher'
									? 'Nauczyciel'
									: role === 'student'
										? 'Uczeń'
										: role}
					</Typography>
				</Button>
			</Tooltip>
		</PanelLayout>
	);
};

const PanelPage = () => {
	return (
		<OlympicsContextProvider>
			<PresentationChromeProvider>
				<PanelPageContent />
			</PresentationChromeProvider>
		</OlympicsContextProvider>
	);
};

export default PanelPage;
